export default function() {
    return {
        messages: [],
        currentMessage: '',
        eventSource: null
    }
}
